module.exports = __webpack_public_path__ + "static/img/elven_skirmisher1.1e2c042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/elven_skirmisher1.png
// module id = OOMg
// module chunks = 0